export const globalIcons = {
  EditProjectIcon: `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="currentColor"
    class="bi bi-pencil-square mr-1"
    viewBox="0 0 16 16"
  >
    <path
      d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
    />
    <path
      fill-rule="evenodd"
      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
    />
  </svg>`,
  ProjectShareIcon: `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="currentColor"
  class="bi bi-upload mr-2"
  viewBox="0 0 16 16"
>
  <path
    d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"
  />
  <path
    d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"
  />
</svg>`,
ProjectProductSeacrhIcon: `<svg
xmlns="http://www.w3.org/2000/svg"
width="16"
height="16"
fill="currentColor"
class="bi bi-search my-project-search-icon"
viewBox="0 0 16 16"
>
<path
  d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
/>
</svg>`,

IconMaintenance:`<svg version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 152.53 198.28" style="enable-background:new 0 0 152.53 198.28;" xml:space="preserve">
<style type="text/css">
	.st0{fill:none;stroke:#171717;stroke-width:4;stroke-linejoin:round;}
	.st1{fill:none;stroke:#231F20;stroke-width:1.9164;stroke-linejoin:round;stroke-miterlimit:10;}
	.st2{fill:none;stroke:#231F20;stroke-width:1.9164;stroke-miterlimit:10;}
	.st3{fill:none;stroke:#231F20;stroke-width:2.75;stroke-linejoin:round;stroke-miterlimit:10;}
</style>
<g>
	<g>
		<path id="Path_21-2" class="st0" d="M101.48,11.19V48.5h39.24L101.48,11.19z"/>
		<path id="Path_22-2" class="st0" d="M11.81,11.14v176h128.91V47.97l-39.11-36.84H11.81z"/>
	</g>
	<g>
		<path class="st1" d="M81.53,123.54v-2.94c0-0.84,4.33-3.26,5.02-4.33c0.43-0.67,5.9-12.36,5.9-12.36c0-1.55-3.68-1.89-4.96,0
			c-2.71,3.99-4.91,4.91-4.91,4.91l-1.05-2.94V91.13c0-0.98-0.43-1.96-1.98-1.96c-0.9,0-1.92,0.31-1.99,1.96l-0.94,10.8
			 M77.56,91.13v-1.96c0-1.23-0.87-1.97-1.98-1.97h-0.99c-0.6,0-1.86,0.47-1.98,1.97l-0.88,12.77 M72.6,89.17
			c-0.26-0.64-1.13-0.98-1.98-0.98h-0.99c-0.63,0-1.86,0.55-1.98,1.96l-0.88,12.77 M64.66,123.54v-1.97c0-1.32-2.98-4.01-2.98-7.86
			v-6.87l1.02-10.8c0.21-1.88,1.25-2.94,2.95-2.94h1.98"/>
		<path class="st2" d="M89.46,117.69c3.76,0.94,7.37-3.08,7.05-4.91c-1.01-5.83,4.85-12.68,0.54-19.61
			c-3.96-6.37-0.1-12.79-5.39-10.84c-5.28,1.95-11.29-8.83-14.84-3.37c-3.55,5.46-12.89,2.59-17.76,5.22
			c-4.87,2.63-2.09,8.72-4.38,15c-2.13,5.84-0.79,13.72,4.04,14.58"/>
		<circle class="st3" cx="76.26" cy="99.14" r="37.45"/>
	</g>
</g>
</svg>`,

IconInstallation:`<svg version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 152.53 198.28" style="enable-background:new 0 0 152.53 198.28;" xml:space="preserve">
<style type="text/css">
	.st0{fill:none;stroke:#171717;stroke-width:4;stroke-linejoin:round;}
	.st1{fill:none;stroke:#000000;stroke-width:2.75;stroke-miterlimit:10;}
</style>
<g>
	<g>
		<path id="Path_21-3" class="st0" d="M101.86,11.19V48.5h39.24L101.86,11.19z"/>
		<path id="Path_22-3" class="st0" d="M12.19,11.14v176H141.1V47.97L102,11.14H12.19z"/>
	</g>
	<g>
		<circle class="st1" cx="76.65" cy="107.43" r="33.15"/>
		<circle class="st1" cx="76.65" cy="107.43" r="23.94"/>
		<path class="st1" d="M76.65,66.91h9.21c2.03,0,3.68,1.65,3.68,3.68v5.53"/>
		<path class="st1" d="M63.75,76.12v-5.53c0-2.03,1.65-3.68,3.68-3.68h5.53"/>
		<polyline class="st1" points="69.28,63.22 69.28,57.7 84.01,57.7 84.01,63.22 		"/>
		<line class="st1" x1="76.65" y1="131.37" x2="76.65" y2="124"/>
		<line class="st1" x1="100.59" y1="107.43" x2="93.22" y2="107.43"/>
		<line class="st1" x1="56.39" y1="107.43" x2="71.12" y2="107.43"/>
		<line class="st1" x1="55.94" y1="118.85" x2="61.56" y2="115.61"/>
		<circle class="st1" cx="76.65" cy="107.43" r="5.99"/>
		<line class="st1" x1="81.02" y1="102.6" x2="87.02" y2="95.7"/>
		<line class="st1" x1="76.65" y1="91.08" x2="76.65" y2="83.71"/>
	</g>
</g>
</svg>`,

IconWarranty: `<svg version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 152.53 198.28" style="enable-background:new 0 0 152.53 198.28;" xml:space="preserve">
<style type="text/css">
.st0{fill:none;stroke:#171717;stroke-width:4;stroke-linejoin:round;}
</style>
<g>
<g id="Group_42" transform="translate(494 30.337)">
 <path id="Path_21" class="st0" d="M-392.52-19.99v37.31h39.24L-392.52-19.99z"/>
 <path id="Path_22" class="st0" d="M-482.19-20.04v176h128.91V16.8l-39.11-36.84H-482.19z"/>
</g>
<g>
 <path d="M115.74,77.27c-0.21,13.37-2.55,26.21-8.96,38.08c-6.56,12.14-16.43,20.57-29.23,25.58c-0.85,0.33-2.08,0.24-2.95-0.11
   c-15.71-6.29-26.54-17.46-32.48-33.24c-4.97-13.19-6.27-26.87-4.69-40.86c0.2-1.78,0.98-2.38,2.71-2.37
   c8.83,0.01,17.56-0.88,25.88-3.98c3.06-1.14,5.91-2.84,8.8-4.4c0.95-0.52,1.71-0.79,2.67-0.11c6.18,4.38,13.25,6.41,20.62,7.39
   c4.76,0.63,9.58,0.85,14.38,1.09c1.71,0.08,2.46,0.75,2.57,2.36C115.28,70.22,115.51,73.75,115.74,77.27z M111.76,67.74
   c-0.8,0-1.39,0.02-1.99,0c-11.42-0.46-22.58-2-32.67-7.97c-0.47-0.28-1.37-0.15-1.93,0.1c-2.39,1.07-4.65,2.43-7.08,3.37
   c-8.23,3.19-16.85,4.29-25.61,4.48c-1.22,0.03-1.87,0.18-1.98,1.62c-0.79,10.67-0.06,21.19,2.93,31.5
   c4.91,16.94,14.93,29.51,31.47,36.4c0.74,0.31,1.82,0.35,2.55,0.05c12.04-4.93,21.05-13.2,27.01-24.78
   c4.1-7.96,6.24-16.49,7.26-25.31C112.45,80.82,112.5,74.42,111.76,67.74z"/>
 <path d="M68.91,101.16c5.87-5.9,11.54-11.61,17.21-17.31c1.94-1.95,3.87-3.89,5.82-5.82c1.5-1.49,2.1-1.48,3.64,0.05
   c1.64,1.63,3.28,3.27,4.92,4.91c1.73,1.73,1.76,2.36,0.06,4.07c-6.98,6.99-13.97,13.97-20.96,20.95
   c-2.98,2.97-5.94,5.96-8.94,8.91c-1.48,1.46-2.15,1.4-3.64-0.1c-4.12-4.16-8.25-8.31-12.38-12.45c-2.16-2.17-2.17-2.61-0.04-4.72
   c1.56-1.54,3.09-3.12,4.65-4.67c1.39-1.38,2.18-1.41,3.57-0.04C64.79,96.93,66.74,98.95,68.91,101.16z M93.4,80.74
   c-0.36,0.57-0.61,1.17-1.03,1.59c-7.14,7.17-14.3,14.33-21.47,21.48c-1.84,1.84-2.3,1.84-4.16-0.07
   c-1.82-1.88-3.62-3.78-5.32-5.57c-1.54,1.39-2.86,2.58-4.31,3.89c4.11,3.92,8.05,7.69,11.69,11.16
   c9.43-9.4,18.98-18.93,28.57-28.49C96.27,83.62,95.03,82.38,93.4,80.74z"/>
</g>
</g>
</svg>`,

ConstructionSpec:`<svg version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 152.53 198.28" style="enable-background:new 0 0 152.53 198.28;" xml:space="preserve">
<style type="text/css">
.st0{fill:none;stroke:#171717;stroke-width:4;stroke-linejoin:round;}
.st1{clip-path:url(#SVGID_00000080898560735417156560000014561764015958083491_);}
.st2{fill:none;stroke:#000000;stroke-width:2.75;stroke-linejoin:round;stroke-miterlimit:10;}
</style>
<g>
<g id="Group_45" transform="translate(1113 30.337)">
 <path id="Path_21-4" class="st0" d="M-1011.88-19.15v37.31h39.24L-1011.88-19.15z"/>
 <path id="Path_22-4" class="st0" d="M-1101.55-19.2v176h128.91V17.64l-39.11-36.84H-1101.55z"/>
</g>
<g>
 <defs>
   <path id="SVGID_1_" d="M38.4,102.92c0,20.71,16.79,37.5,37.5,37.5c20.71,0,37.5-16.79,37.5-37.5c0-20.71-16.79-37.5-37.5-37.5
     C55.19,65.42,38.4,82.21,38.4,102.92L38.4,102.92z"/>
 </defs>
 <clipPath id="SVGID_00000057107431456374663210000006513967746260704703_">
   <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
 </clipPath>
 <path style="clip-path:url(#SVGID_00000057107431456374663210000006513967746260704703_);" d="M-0.59,109.28h82.34l-2.12-1.05
   c-0.67-0.33-0.94-1.14-0.61-1.81c0.33-0.67,1.14-0.94,1.81-0.61l7.03,3.49c0.65,0.09,1.16,0.65,1.16,1.33
   c0,0.74-0.6,1.35-1.35,1.35H-0.59c-0.74,0-1.35-0.6-1.35-1.35C-1.94,109.88-1.34,109.28-0.59,109.28L-0.59,109.28z"/>
 <path style="clip-path:url(#SVGID_00000057107431456374663210000006513967746260704703_);" d="M-0.59,116.54h88.27
   c0.74,0,1.35,0.6,1.35,1.35c0,0.74-0.6,1.35-1.35,1.35H-0.59c-0.74,0-1.35-0.6-1.35-1.35C-1.94,117.14-1.34,116.54-0.59,116.54
   L-0.59,116.54z"/>
 <path style="clip-path:url(#SVGID_00000057107431456374663210000006513967746260704703_);" d="M-0.59,123.81h88.27
   c0.74,0,1.35,0.6,1.35,1.35c0,0.74-0.6,1.35-1.35,1.35H-0.59c-0.74,0-1.35-0.6-1.35-1.35C-1.94,124.41-1.34,123.81-0.59,123.81
   L-0.59,123.81z"/>
 <path style="clip-path:url(#SVGID_00000057107431456374663210000006513967746260704703_);" d="M86.16,92.49
   c0.02,0.04,0.04,0.08,0.05,0.12c0.01,0.04,0.03,0.08,0.04,0.12c0.01,0.04,0.02,0.08,0.03,0.13c0.01,0.04,0.01,0.08,0.01,0.13
   c0,0.04,0.01,0.09,0.01,0.13c0,0.04-0.01,0.09-0.01,0.13c-0.01,0.04-0.01,0.09-0.02,0.13c-0.01,0.04-0.03,0.09-0.04,0.13
   c-0.01,0.03-0.01,0.06-0.03,0.09c-0.01,0.02-0.02,0.04-0.03,0.07c0,0,0,0,0,0.01c0,0,0,0,0,0c-2.87,6.71-9.43,11.03-16.73,11.03
   l-70.04-0.01c-0.74,0-1.35-0.6-1.35-1.35c0-0.74,0.6-1.35,1.35-1.35l70.04,0.01c5.81,0,11.07-3.23,13.73-8.32l-34.7-17.2
   c-0.67-0.33-0.94-1.14-0.61-1.81c0.33-0.67,1.14-0.94,1.81-0.61l35.88,17.79c0.03,0.02,0.06,0.04,0.08,0.05
   c0.04,0.02,0.08,0.04,0.11,0.07c0.04,0.03,0.07,0.06,0.1,0.09c0.03,0.03,0.06,0.06,0.09,0.09c0.03,0.03,0.06,0.07,0.08,0.11
   c0.03,0.03,0.05,0.07,0.07,0.1C86.12,92.41,86.14,92.45,86.16,92.49L86.16,92.49z"/>
</g>
<path class="st2" d="M38.4,102.92c0,20.71,16.79,37.5,37.5,37.5c20.71,0,37.5-16.79,37.5-37.5c0-20.71-16.79-37.5-37.5-37.5
 C55.19,65.42,38.4,82.21,38.4,102.92L38.4,102.92z"/>
</g>
</svg>`,
FullProductSpec:`<svg version="1.0" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 152.53 198.28" style="enable-background:new 0 0 152.53 198.28;" xml:space="preserve">
<style type="text/css">
.st0{fill:none;stroke:#171717;stroke-width:4;stroke-linejoin:round;}
.st1{clip-path:url(#SVGID_00000016072165881877459380000000035449371057916839_);}
</style>
<g>
<g>
 <path id="Path_21-5" class="st0" d="M101.29,11.19V48.5h39.24L101.29,11.19z"/>
 <path id="Path_22-5" class="st0" d="M11.62,11.14v176h128.91V47.97l-39.11-36.84H11.62z"/>
</g>
<g>
 <defs>
   <circle id="SVGID_1_" cx="76.08" cy="99.14" r="37.5"/>
 </defs>
 <clipPath id="SVGID_00000147942677843701364720000004044835196631179451_">
   <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
 </clipPath>
 <path style="clip-path:url(#SVGID_00000147942677843701364720000004044835196631179451_);" d="M78.89,94.34
   c0-0.09-0.02-0.18-0.04-0.26c-0.01-0.02-0.01-0.04-0.02-0.07c-0.02-0.07-0.05-0.13-0.09-0.19c-0.01-0.02-0.02-0.03-0.03-0.05
   c-0.05-0.07-0.1-0.14-0.16-0.2c-0.01-0.01-0.03-0.02-0.04-0.03c-0.06-0.05-0.12-0.09-0.18-0.12c-0.01-0.01-0.02-0.02-0.03-0.02
   l-13.2-6.64l13.21-6.69c0.36-0.18,0.59-0.55,0.58-0.95c0-0.4-0.23-0.77-0.59-0.95L38.86,58.32c-0.3-0.15-0.66-0.15-0.96,0
   L-1.55,78.16c-0.36,0.18-0.59,0.55-0.59,0.95c0,0.4,0.23,0.77,0.58,0.95l13.21,6.69l-13.2,6.64c-0.01,0.01-0.02,0.02-0.03,0.02
   c-0.06,0.04-0.12,0.08-0.18,0.12c-0.01,0.01-0.03,0.02-0.04,0.03c-0.06,0.06-0.12,0.13-0.16,0.2c-0.01,0.02-0.02,0.03-0.03,0.05
   c-0.03,0.06-0.06,0.13-0.09,0.19c-0.01,0.02-0.01,0.04-0.02,0.07c-0.02,0.08-0.04,0.17-0.04,0.26c0,0,0,0,0,0c0,0,0,0,0,0
   c0,0,0,0,0,0v14.02c0,0.4,0.23,0.77,0.58,0.95l9.02,4.57c0.14,0.13,0.32,0.23,0.52,0.27l2.55,1.29l-12.09,6.06
   c-0.36,0.18-0.59,0.55-0.59,0.95c0,0.4,0.23,0.77,0.58,0.95l39.45,19.97c0.15,0.08,0.32,0.12,0.48,0.12
   c0.17,0,0.33-0.04,0.48-0.12l39.45-19.97c0.36-0.18,0.59-0.55,0.58-0.95c0-0.4-0.23-0.77-0.59-0.95l-12.07-6.07l2.53-1.28
   c0.2-0.04,0.38-0.13,0.52-0.26l9.02-4.57c0.36-0.18,0.58-0.55,0.58-0.95L78.89,94.34C78.89,94.35,78.89,94.35,78.89,94.34
   C78.89,94.35,78.89,94.35,78.89,94.34C78.89,94.35,78.89,94.34,78.89,94.34z M38.38,60.46l37.08,18.65L62.4,85.73
   c-0.11,0.03-0.2,0.09-0.3,0.15L38.38,97.89L14.65,85.88c-0.09-0.06-0.19-0.11-0.29-0.15L1.3,79.12L38.38,60.46z M14.02,87.95
   l23.87,12.09c0.15,0.08,0.32,0.12,0.48,0.12c0.17,0,0.33-0.04,0.48-0.12l23.87-12.09l12.72,6.4l-37.08,18.77L1.3,94.35
   L14.02,87.95z M59.93,116.23V104.6l7.57-3.83v11.63L59.93,116.23z M29.06,122.42v-11.63l8.25,4.18v11.63L29.06,122.42z
    M9.26,112.4v-11.63l7.57,3.83v11.63L9.26,112.4z M18.96,105.68l7.96,4.03v11.63l-7.96-4.03V105.68z M39.45,114.97l8.25-4.18
   v11.63l-8.25,4.18V114.97z M49.83,109.71l7.96-4.03v11.63l-7.96,4.03V109.71z M0,96.08l7.13,3.61v11.63L0,107.71V96.08z
    M75.46,122.46l-37.08,18.77L1.3,122.46l11.61-5.82l24.99,12.65c0.01,0,0.02,0.01,0.03,0.01c0.05,0.02,0.11,0.04,0.16,0.06
   c0.02,0.01,0.04,0.01,0.06,0.02c0.08,0.02,0.15,0.03,0.23,0.03c0.08,0,0.16-0.01,0.23-0.03c0.02,0,0.04-0.01,0.06-0.02
   c0.06-0.02,0.11-0.03,0.16-0.06c0.01,0,0.02-0.01,0.03-0.01l25.01-12.66L75.46,122.46z M69.63,111.32V99.69l7.13-3.61v11.63
   L69.63,111.32z"/>
 <g style="clip-path:url(#SVGID_00000147942677843701364720000004044835196631179451_);">
   <path d="M111.41,78.01l3.64,0.97l-0.91,3.41c2.33,0.97,4.28,2.52,5.74,4.43l3.02-1.75l1.89,3.26l-3.05,1.77
     c0.89,2.21,1.22,4.65,0.88,7.12l3.48,0.92l-0.97,3.64l-3.52-0.94c-0.97,2.26-2.49,4.16-4.35,5.58l1.86,3.22l-3.26,1.89
     l-1.88-3.24c-1.64,0.66-3.4,1.02-5.22,1.02c-0.58,0-1.17-0.04-1.75-0.11l-0.93,3.5l-3.64-0.97l0.93-3.49
     c-2.25-0.94-4.15-2.41-5.6-4.24l-3.23,1.87l-1.89-3.26l3.2-1.86c-0.92-2.17-1.29-4.58-1.01-7.02l-3.5-0.93l0.97-3.64l3.45,0.92
     c0.93-2.32,2.44-4.28,4.32-5.75l-1.76-3.03l3.26-1.89l1.74,3.01c1.69-0.71,3.53-1.1,5.41-1.1c0.58,0,1.17,0.04,1.76,0.11
     L111.41,78.01 M111.41,75.26c-0.48,0-0.96,0.13-1.38,0.37c-0.63,0.37-1.09,0.97-1.28,1.67l-0.33,1.26
     c-1.3,0.02-2.58,0.2-3.84,0.52l-0.62-1.07c-0.37-0.63-0.97-1.09-1.67-1.28c-0.23-0.06-0.47-0.09-0.71-0.09
     c-0.48,0-0.96,0.13-1.38,0.37l-3.26,1.89c-0.63,0.37-1.09,0.97-1.28,1.67c-0.19,0.7-0.09,1.46,0.28,2.09l0.65,1.12
     c-0.88,0.93-1.65,1.95-2.29,3.05l-1.28-0.34c-0.23-0.06-0.47-0.09-0.71-0.09c-0.48,0-0.96,0.13-1.38,0.37
     c-0.63,0.37-1.09,0.97-1.28,1.67l-0.97,3.64c-0.39,1.47,0.48,2.97,1.95,3.36l1.38,0.37c0.04,1.24,0.21,2.48,0.52,3.68l-1.26,0.73
     c-0.63,0.37-1.09,0.97-1.28,1.67c-0.19,0.7-0.09,1.46,0.28,2.09l1.89,3.26c0.37,0.63,0.97,1.09,1.67,1.28
     c0.23,0.06,0.47,0.09,0.71,0.09c0.48,0,0.96-0.13,1.38-0.37l1.32-0.77c0.88,0.83,1.85,1.57,2.89,2.2l-0.36,1.35
     c-0.39,1.47,0.48,2.97,1.95,3.36l3.64,0.97c0.23,0.06,0.47,0.09,0.71,0.09c0.48,0,0.96-0.13,1.38-0.37
     c0.63-0.37,1.09-0.97,1.28-1.67l0.36-1.35c1.22-0.02,2.43-0.18,3.61-0.47l0.77,1.33c0.37,0.63,0.97,1.09,1.67,1.28
     c0.23,0.06,0.47,0.09,0.71,0.09c0.48,0,0.96-0.13,1.38-0.37l3.26-1.89c1.31-0.76,1.76-2.44,1-3.76l-0.74-1.28
     c0.86-0.89,1.62-1.87,2.27-2.92l1.4,0.37c0.24,0.06,0.47,0.09,0.71,0.09c1.22,0,2.33-0.81,2.66-2.04l0.97-3.64
     c0.39-1.47-0.48-2.97-1.95-3.36l-1.3-0.35c-0.01-1.27-0.17-2.53-0.47-3.77l1.14-0.66c1.31-0.76,1.76-2.44,1-3.76l-1.89-3.26
     c-0.37-0.63-0.97-1.09-1.67-1.28c-0.23-0.06-0.47-0.09-0.71-0.09c-0.48,0-0.96,0.13-1.38,0.37l-1.08,0.62
     c-0.93-0.91-1.96-1.7-3.07-2.37l0.34-1.26c0.19-0.7,0.09-1.46-0.28-2.09c-0.37-0.63-0.97-1.09-1.67-1.28l-3.64-0.97
     C111.89,75.29,111.65,75.26,111.41,75.26L111.41,75.26z"/>
 </g>
 <g style="clip-path:url(#SVGID_00000147942677843701364720000004044835196631179451_);">
   <path d="M108.75,88.71c0.57,0,1.14,0.07,1.71,0.23c3.55,0.94,5.66,4.58,4.71,8.13c-0.79,2.97-3.48,4.94-6.42,4.94
     c-0.57,0-1.14-0.07-1.71-0.23c-3.55-0.94-5.66-4.58-4.71-8.13C103.13,90.67,105.81,88.71,108.75,88.71 M108.75,85.96
     C108.75,85.96,108.75,85.96,108.75,85.96c-4.25,0-7.98,2.87-9.07,6.98c-1.33,5.01,1.66,10.16,6.66,11.49
     c0.79,0.21,1.61,0.32,2.42,0.32c4.25,0,7.98-2.87,9.07-6.98c0.65-2.42,0.31-4.96-0.95-7.13c-1.26-2.17-3.29-3.72-5.71-4.37
     C110.38,86.06,109.57,85.96,108.75,85.96L108.75,85.96z"/>
 </g>
 <use xlink:href="#SVGID_1_"  style="overflow:visible;fill:none;stroke:#000000;stroke-width:2.75;stroke-miterlimit:10;"/>
</g>
</g>
</svg>`,

IconSustainability:`<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 152.5 198.3" style="enable-background:new 0 0 152.5 198.3;" xml:space="preserve">
<style type="text/css">
.st0{fill:none;stroke:#171717;stroke-width:4;stroke-linejoin:round;}
.st1{fill:none;stroke:#000000;stroke-width:2.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
.st2{fill:none;stroke:#000000;stroke-width:2.75;stroke-linejoin:round;stroke-miterlimit:10;}
.st3{fill:none;stroke:#000000;stroke-width:2.75;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}
.st4{fill:none;stroke:#000000;stroke-width:2.75;stroke-miterlimit:10;}
.st5{fill:#231F20;}
.st6{fill:none;stroke:#231F20;stroke-width:2.75;stroke-miterlimit:10;}
</style>
<g>
<path id="Path_21-4_00000015344174953104536550000018063312578063840444_" class="st0" d="M101.7,11.1v37.3H141L101.7,11.1z"/>
<path id="Path_22-4_00000053547757828871226170000005589001988043272844_" class="st0" d="M12,11v176H141V47.8L101.8,11H12z"/>
<path class="st1" d="M41.2,115.8c0-17.3,14.1-31.4,31.4-31.4h6.3"/>
<polyline class="st2" points="71.8,75.5 78.9,84.4 69.9,91.5 	"/>
<path class="st3" d="M100.6,113c0,5.9-2.3,11.3-6.1,15.4"/>
<path class="st1" d="M89,131.3c-8.7,0-16.4-7.7-16.4-16.4c0-13.4,12.7-18.3,12.7-25.6c3.2,1.2,6.2,3.1,8.6,5.4"/>
<path class="st4" d="M89.9,111.2v16.4c0,4.4-0.8,8.1-3.6,10.9"/>
<g>
 <path class="st5" d="M99.4,96v4.7h4.7v4.1h-4.7v4.7h-4.1v-4.7h-4.7v-4.1h4.7V96H99.4 M102.1,93.3h-2.8h-4.1h-2.8V96v2h-2h-2.8v2.8
   v4.1v2.8h2.8h2v2v2.8h2.8h4.1h2.8v-2.8v-2h2h2.8v-2.8v-4.1V98h-2.8h-2v-2V93.3L102.1,93.3z"/>
</g>
<circle class="st6" cx="76.5" cy="102.8" r="37.5"/>
</g>
</svg>`,

IconLookBook: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 152.5 198.3">
  <defs>
    <style>
      .cls-1, .cls-2 {
        stroke-width: 0px;
      }

      .cls-1, .cls-3, .cls-4 {
        fill: none;
      }

      .cls-2 {
        fill: #000;
      }

      .cls-3 {
        stroke: #171717;
        stroke-linejoin: round;
        stroke-width: 4px;
      }

      .cls-4 {
        stroke: #000;
        stroke-miterlimit: 10;
        stroke-width: 2.8px;
      }
    </style>
  </defs>
  <g>
    <g>
      <path id="Path_21-5" data-name="Path 21-5" class="cls-3" d="M101.3,11.2v37.3h39.2L101.3,11.2Z"/>
      <path id="Path_22-5" data-name="Path 22-5" class="cls-3" d="M11.6,11.1v176h128.9V48L101.4,11.1H11.6Z"/>
    </g>
    <circle id="SVGID" class="cls-4" cx="76.1" cy="99.1" r="37.5"/>
  </g>
  <g>
    <path class="cls-1" d="M84,83.4c-3.1-1.8-6.5-3-9.8-4.4-.7-.3-1.5-.6-2.3-.9-5.6,14.5-11.1,28.9-16.7,43.3,7.7,2.8,15.6,5.2,20.9,12.2.4-.8.7-1.4,1-2,4.8-12.4,9.5-24.7,14.2-37.1.2-.4.1-.9,0-1.3-1.3-4.1-3.6-7.6-7.4-9.7Z"/>
    <path class="cls-1" d="M76.1,63.2c-19.9,0-36.1,16.2-36.1,36.1s1.8,13,5,18.4c4.5-11.6,9-23.3,13.5-34.9.9-2.4,1.4-2.7,3.9-1.8,1.5.5,3,1.2,4.5,1.7.6-1.6,1.2-3.1,1.8-4.6,1.4-3.3,1.7-3.5,5-2.3,3.1,1.2,6.2,2.4,9.2,3.8,4.8,2.2,8.1,6,10.4,10.7.2.5.5,1,.8,1.7.6-.3,1.1-.7,1.7-.9,5-2.2,10-2.5,15.2-.6-4-15.6-18.2-27.2-35-27.2Z"/>
    <path class="cls-1" d="M64.2,127.9c-3.1-1.1-6.1-2.2-9.2-3.4-.8-.3-1.6-.8-2.4-1.2-.6-.3-.9-.8-.6-1.5.3-1,.6-1.9,1-2.9,4.2-10.7,8.3-21.4,12.5-32.1.2-.4.3-.9.5-1.3-1.7-.6-3.2-1.2-4.7-1.8-4.8,12.3-9.5,24.6-14.2,37,6.1,8.3,15.6,13.8,26.5,14.6-.4-.6-.9-1.2-1.3-1.7-2.1-2.6-4.7-4.5-7.9-5.7Z"/>
    <g>
      <path class="cls-2" d="M79.2,135.3c2.1-.2,4.1-.5,6.1-1l-6.1,1Z"/>
      <path class="cls-2" d="M79.2,135.3c-.1,0-.3,0-.4,0,0,0,0,0,0,0h.4Z"/>
      <path class="cls-2" d="M111.1,90.3c-5.1-1.9-10.2-1.5-15.2.6-.6.3-1.1.6-1.7.9-.4-.8-.6-1.2-.8-1.7-2.3-4.7-5.5-8.5-10.4-10.7-3-1.4-6.1-2.6-9.2-3.8-3.3-1.3-3.7-1.1-5,2.3-.6,1.5-1.2,3-1.8,4.6-1.5-.6-3-1.2-4.5-1.7-2.5-.8-3-.6-3.9,1.8-4.5,11.6-9,23.3-13.5,34.9.6,1.1,1.3,2.1,2,3.1,4.7-12.3,9.5-24.6,14.2-37,1.5.6,3.1,1.2,4.7,1.8-.2.4-.3.9-.5,1.3-4.2,10.7-8.3,21.4-12.5,32.1-.4.9-.6,1.9-1,2.9-.3.7,0,1.2.6,1.5.8.4,1.6.9,2.4,1.2,3,1.2,6.1,2.3,9.2,3.4,3.2,1.1,5.8,3.1,7.9,5.7.5.6.9,1.1,1.3,1.7.9,0,1.7.1,2.6.1s1.8,0,2.7-.1c0-.4.4-1.4.5-1.7,4.8-12.6,9.7-25.2,14.6-37.8.2-.5.7-1.1,1.2-1.4,5-2.8,10.3-3.2,15.7-1.3.3.1.6.2.9.3-.2-1.1-.4-2.1-.7-3.2ZM91.3,94.5c-4.7,12.4-9.5,24.7-14.2,37.1-.2.6-.6,1.2-1,2-5.3-7-13.1-9.4-20.9-12.2,5.6-14.4,11.1-28.8,16.7-43.3.8.3,1.5.6,2.3.9,3.3,1.4,6.7,2.7,9.8,4.4,3.8,2.1,6,5.6,7.4,9.7.1.4.1.9,0,1.3Z"/>
    </g>
    <path class="cls-2" d="M113.2,94c.5.2,1,.4,1.5.6-.1-1-.3-2.1-.5-3.1-.5-.2-1-.4-1.5-.6.2,1,.4,2.1.6,3.1Z"/>
    <path class="cls-2" d="M111.3,90.4c0,0-.2,0-.3,0,.3,1,.5,2.1.7,3.2.5.2,1,.4,1.5.5-.1-1.1-.3-2.1-.6-3.1-.4-.2-.9-.3-1.3-.5Z"/>
  </g>
</svg>`,

IdeaBook:`/getmedia/01944c90-6059-42d4-859d-0ea59a441d3c/IdeaBook_cover_hero_v10.jpg.aspx?width=796&height=540&ext=.jpg`,

defaultImage: `https://shawfloors.widen.net/content/2kzafkruxw/png/-default.png`

}
